/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useFormikContext } from "formik";
import { AddSolutionFormValues } from "../../../types";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import Intervention from "./Intervention";

function InterventionsContainer({ open }: { open: boolean }) {
  const context = useFormikContext<AddSolutionFormValues>();

  const { interventions } = context.values;

  const [interventionsNo, setInterventionsNo] = useState<number>(
    interventions.length,
  );
  const generateNewContainer = () => {
    const containerTracker = interventionsNo + 1;
    setInterventionsNo(containerTracker);

    const nextValues = [
      ...context.values.interventions,
      { action: [], ecosystem: [], interventionCounter: containerTracker },
    ];
    context.setFieldValue("interventions", nextValues, true);

    const prevTouched =
      (context.touched?.interventions as Array<any> | undefined) ?? [];
    const nextTouched = [...prevTouched, { action: false, ecosystem: false }];
    context.setTouched(
      { ...context.touched, interventions: nextTouched },
      false,
    );
  };

  return (
    <Box data-testid="writeable-interventions-container">
      <SectionCollapsible open={open} label="Interventions">
        {interventions &&
          interventions
            .sort((a, b) =>
              a.interventionCounter > b.interventionCounter ? 1 : -1,
            )
            .map((intervention) => {
              const formikIndex = context.values.interventions.findIndex(
                (i) =>
                  i.interventionCounter === intervention.interventionCounter,
              );
              return (
                <Box
                  key={intervention.interventionCounter}
                  sx={{ paddingBottom: 4 }}
                >
                  <Intervention value={intervention} index={formikIndex} />
                </Box>
              );
            })}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={generateNewContainer}
            sx={{
              paddingTop: 1,
              "&:hover": { backgroundColor: "transparent" },
            }}
            aria-label="add-intervention-button"
            data-testid="add-intervention-button"
            size="large"
          >
            <AddIcon />
            <Typography variant="body2">Add intervention</Typography>
          </IconButton>
        </Box>
      </SectionCollapsible>
    </Box>
  );
}

export default InterventionsContainer;
